import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Box, Button, FlexGrid, StackView } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

import TankNumber from './components/tankNumber';
import TankName from './components/tankName';
import TankProduct from './components/tankProduct';
import TankType from './components/tankType';
import TankHeight from './components/tankHeight';
import TankLength from './components/tankLength';
import TankCapacity from './components/tankCapacity';
import TankMaterial from './components/tankMaterial';
import TankSensorType from './components/tankSensorType';
import TankPortSize from './components/tankPortSize';
import TankOptionalStand from './components/tankOptionalStand';

const AddDetailsForm = ({ tankDetails, setTankDetails, sectionError }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    assigneeSRTModal: { addButton }
  } = localizedStrings;

  const initialState = {
    valueTankNumber: '',
    valueTankName: '',
    valueTankProduct: '',
    valueTankProductOther: '',
    valueTankType: '',
    valueTankHeight: '',
    valueTankLength: '',
    valueTankCapacity: '',
    valueTankMaterial: '',
    valueTankMaterialOther: '',
    valueTankSensorType: '',
    valueTankPortSize: '',
    valueTankPortSizeOther: '',
    valueTankOptionalStand: ''
  };

  const [dataField, setDataField] = useState(initialState);
  const [error, setError] = useState('');

  const fields = [
    TankNumber,
    TankName,
    TankProduct,
    TankType,
    TankHeight,
    TankLength,
    TankCapacity,
    TankMaterial,
    TankSensorType,
    TankPortSize,
    TankOptionalStand
  ];

  const validateForm = () => {
    let formValid = [
      'valueTankNumber',
      'valueTankName',
      'valueTankProduct',
      'valueTankType',
      'valueTankHeight',
      'valueTankLength',
      'valueTankCapacity',
      'valueTankMaterial',
      'valueTankSensorType',
      'valueTankPortSize',
      'valueTankOptionalStand'
    ].every(field => dataField[field] !== '');

    if (
      dataField.valueTankProduct === 'Other' &&
      !dataField.valueTankProductOther
    )
      formValid = false;
    if (
      dataField.valueTankMaterial === 'Other' &&
      !dataField.valueTankMaterialOther
    )
      formValid = false;
    if (
      dataField.valueTankPortSize === 'Other' &&
      !dataField.valueTankPortSizeOther
    )
      formValid = false;
    return formValid;
  };

  const onAddInfo = () => {
    if (!validateForm()) {
      setError('Please enter all necessary information');
      return;
    }
    setTankDetails([...tankDetails, dataField]);
    setDataField(initialState);
    setError('');
  };

  useEffect(() => {
    setError(sectionError);
  }, [sectionError]);

  return (
    <StackView space={3}>
      <FlexGrid>
        {fields.map(Field => (
          <FlexGrid.Row>
            <FlexGrid.Col>
              <Field
                dataField={dataField}
                setDataField={setDataField}
                error={error}
              />
            </FlexGrid.Col>
          </FlexGrid.Row>
        ))}
      </FlexGrid>
      <Box style={{ padding: '1.5rem' }}>
        <Button onPress={onAddInfo}>{addButton}</Button>
      </Box>
    </StackView>
  );
};

AddDetailsForm.propTypes = {
  tankDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
  setTankDetails: PropTypes.func.isRequired,
  sectionError: PropTypes.string.isRequired
};

export default AddDetailsForm;
